<template>
  <v-form>
    <v-row align="start">
      <v-col cols="12" md="6">
        <select-field-with-title
          v-model="selectedChild"
          label="Pour quel élève ?"
          :items="childrens"
          :itemTitle="'name'"
          :hide-details="true"
          :returnObject="true"
          variant="underlined"
          :persistent-placeholder="false"
        ></select-field-with-title>
      </v-col>
    </v-row>
    <v-row>
      <router-link
        to="child-creation"
        class="form-link text-start pl-3 mb-3"
      >
        Ajouter ou modifier un autre enfant
      </router-link>
    </v-row>
    <v-row class="align-end">
      <v-col cols="12" md="6" class="pt-0 mb-1">
        <v-row>
          <v-col cols="12" class="pb-0 mb-2">
            <div class="field-label text-start">Pour quelle année scolaire</div>
          </v-col>
        </v-row>
        <select-field-with-title
          v-model="selectedYear"
          label=""
          placeholder="Sélectionner"
          :items="years"
          :itemTitle="'label'"
          :itemValue="'code'"
          :hide-details="true"
          variant="underlined"
        ></select-field-with-title>
      </v-col>
      <v-col v-if="selectedYear" cols="12" md="6" class="pt-0 mb-1">
        <v-row>
          <v-col cols="12" class="pb-0 mb-2">
            <div class="field-label text-start">Classe pour l'année choisie</div>
          </v-col>
        </v-row>
        <select-field-with-title
          v-model="selectedClass"
          label=""
          placeholder="Choisissez la classe"
          :items="classes"
          :itemTitle="'label'"
          :itemValue="'code'"
          :hide-details="true"
          variant="underlined"
        ></select-field-with-title>
      </v-col>
      <v-col
        v-if="
          selectedChild &&
          selectedClass &&
          filteredProductsByFormationWithoutStage.length > 0
        "
        cols="12"
        md="6"
        class="pt-0"
      >
        <v-select
          v-model="selectedFormation"
          label="Choisissez une préparation"
          :items="filteredProductsByFormation"
          :itemTitle="'title'"
          :itemValue="'value'"
          :hide-details="true"
          density="compact"
          variant="underlined"
        >
        </v-select>
      </v-col>
      <v-col
        v-if="
          (selectedChild &&
            filteredProductsByClass.length > 0 &&
            selectedFormation == 'STAGE') ||
          (selectedClass && filteredProductsByFormationWithoutStage.length < 1)
        "
        cols="12"
        md="6"
        class="pt-0"
      >
        <select-field-with-title
          v-model="selectedDiscipline"
          label="Choisissez une matière"
          :items="filteredProductsByClass"
          :itemTitle="'title'"
          :itemValue="'value'"
          :chips="true"
          :closableChips="true"
          :multiple="true"
          :hide-details="true"
          variant="underlined"
        ></select-field-with-title>
      </v-col>

      <slot />
    </v-row>
    <v-progress-circular
      v-if="loading"
      class="mt-5"
      indeterminate
      color="primary"
    ></v-progress-circular>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import SelectFieldWithTitle from "@/components/form-base/SelectFieldWithTitleBase.vue";

export default {
  components: {
    SelectFieldWithTitle,
  },

  props: {
    resetResults: Function,
    selectedYearValue: Number,
  },

  data() {
    return {
      loading: false,
      selectedChild: null,
      selectedClass: null,
      childClass: null,
      selectedDiscipline: null,
      selectedFormation: null,
      captionsFormations: [],
      captionsMatieres: [],
      childrens: [],
      classes: [],
      years: [],
      products: [],
    };
  },

  computed: {
    ...mapGetters("payload", ["getStudents"]),

    filteredProductsByClass: function () {
      let productsAlreadyAdd = [];
      const currentDate = moment();
      // Strict subject filter only for « Stages intensifs par matière » (STAGE).
      // Other preparations: keep previous behaviour (class + matière only).
      const isStageContext =
        this.selectedFormation === "STAGE" ||
        (this.selectedClass &&
          this.filteredProductsByFormationWithoutStage.length < 1);

      let products = this.products
        .filter((item) => {
          if (item.class_code != this.childClass || !item.admission_modality) {
            return false;
          }
          if (!isStageContext) {
            return true;
          }
          if (item.rhythm !== "STAGE") {
            return false;
          }
          if (!this.hasValidProductAction(item, currentDate)) {
            return false;
          }
          if (
            this.selectedYear &&
            !item.actions.some(
              (action) => action.year_id === this.selectedYear
            )
          ) {
            return false;
          }
          return true;
        })
        .map((item) => {
          if (
            item.admission_modality &&
            !productsAlreadyAdd.includes(item.admission_modality)
          ) {
            productsAlreadyAdd.push(item.admission_modality);
            const caption = this.captionsMatieres.find(
              (discipline) => discipline.code === item.admission_modality
            );
            if (caption) {
              return {
                value: item.admission_modality,
                title: caption.label,
                order: caption.order,
              };
            }
          }
        })
        .filter(
          (value, index, categoryArray) =>
            categoryArray.indexOf(value) === index && value !== undefined
        )
        .sort((a, b) => {
          if (a.order === null && b.order === null) {
            return 0;
          } else if (a.order === null) {
            return 1;
          } else if (b.order === null) {
            return -1;
          } else {
            return a.order - b.order;
          }
        });

      return products;
    },

    filteredProductsByFormation: function () {
      let productsAlreadyAdd = [];
      let products = this.products
        .filter((item) => {
          return item.class_code == this.childClass;
        })
        .map((item) => {
          if (item.rhythm && !productsAlreadyAdd.includes(item.rhythm)) {
            productsAlreadyAdd.push(item.rhythm);
            const caption = this.captionsFormations.find(
              (discipline) => discipline.code === item.rhythm
            );
            return {
              value: item.rhythm,
              title: caption.label,
              order: caption.order,
            };
          }
        })
        .sort((a, b) => {
          if (a.order === null && b.order === null) {
            return 0;
          } else if (a.order === null) {
            return 1;
          } else if (b.order === null) {
            return -1;
          } else {
            return a.order - b.order;
          }
        });

      products = products.filter(
        (value, index, categoryArray) =>
          categoryArray.indexOf(value) === index && value !== undefined
      );

      return products;
    },

    filteredProductsByFormationWithoutStage() {
      if (
        this.filteredProductsByFormation &&
        this.filteredProductsByFormation.length > 0 &&
        this.filteredProductsByFormation[0].value === "STAGE"
      ) {
        return this.filteredProductsByFormation.slice(1);
      } else {
        return this.filteredProductsByFormation;
      }
    },

    hasStageItem() {
      return (
        this.filteredProductsByFormation &&
        this.filteredProductsByFormation.length > 0 &&
        this.filteredProductsByFormation[0].value === "STAGE"
      );
    },

    getYearSchool() {
      if (!this.selectedYear) {
        return null;
      }

      const getYearById = this.years.find(
        (year) => year.code === this.selectedYear
      );

      if (!getYearById) {
        return null;
      }

      const splitYear = getYearById.label.split("-");

      if (splitYear.length < 2) {
        return null;
      }

      const startYear = parseInt(splitYear[0]);
      const endYear = parseInt(splitYear[1]);

      return Math.min(startYear, endYear);
    },

    selectedYear: {
      get() {
        return this.selectedYearValue;
      },
      set(val) {
        this.$emit("update:selectedYearValue", val);
      },
    },
  },

  methods: {
    getClassesConstants() {
      this.$store.dispatch("getClassesConstants").then((response) => {
        this.classes = response;
      });
    },

    getFormationsConstants() {
      this.$store.dispatch("getFormationsConstants").then((response) => {
        this.captionsFormations = response;
      });
    },

    getYearsConstants() {
      this.$store.dispatch("getYearsConstants").then((response) => {
        this.years = response.filter((year) => year.label !== "2025-2026");
        const defaultYear = this.years.find((year) => year.label === "2026-2027");
        if (defaultYear && !this.selectedYear) {
          this.selectedYear = defaultYear.code;
        }
      });
    },

    getProducts() {
      this.$store.dispatch("getProducts").then((response) => {
        this.products = response;
      });
    },

    getChildrens() {
      this.childrens = this.getStudents.map((student, index) => ({
        name: `${student.firstname} ${student.lastname}`,
        index: index,
      }));
      this.selectedChild = this.childrens[0];
      this.$emit("child-selected", this.selectedChild);
    },

    getSubjectsConstants() {
      this.$store.dispatch("getSubjectsConstants").then((response) => {
        this.captionsMatieres = response;
      });
    },

    filterProducts() {
      const selectedDiscipline = this.selectedDiscipline;
      const selectedFormation =
        this.selectedFormation === "STAGE" ||
        this.filteredProductsByFormationWithoutStage.length < 1
          ? "STAGE"
          : [this.selectedFormation];
      const childClass = this.childClass;
      const currentDate = moment();

      const filteredProducts = this.products.filter((product) => {
        return this.isProductValid(
          product,
          selectedDiscipline,
          selectedFormation,
          childClass,
          currentDate
        );
      });

      this.$emit("search-results", Object.values(filteredProducts));
    },

    isProductValid(
      product,
      selectedDiscipline,
      selectedFormation,
      childClass,
      currentDate
    ) {
      const matchesDiscipline =
        !selectedDiscipline ||
        selectedDiscipline.includes(product.admission_modality);
      const matchesFormation =
        !selectedFormation || product.rhythm == selectedFormation;
      const matchesClass = !childClass || product.class_code == childClass;
      const hasValidAction = this.hasValidProductAction(product, currentDate);

      return (
        matchesDiscipline && matchesFormation && matchesClass && hasValidAction
      );
    },

    hasValidProductAction(product, currentDate) {
      return product.actions.some((action) => {
        let actionStartDate = moment(action.start_date);

        if (
          action.type_id === 1900036 &&
          action?.start_date_displayed !== null
        ) {
          actionStartDate = moment(action.start_date_displayed);
        }

        const isDateValid = actionStartDate.isSameOrAfter(currentDate);

        // Type 1900036 AF : doit avoir une date de début valide
        const isType1900036Valid = action.type_id === 1900036 && isDateValid;

        // Type 1900341 Formule : logique différente selon le formule_type
        const isType1900341Valid =
          action.type_id === 1900341 &&
          this.isFormuleTypeValid(product.formule_type, isDateValid);

        return isType1900036Valid || isType1900341Valid;
      });
    },

    isFormuleTypeValid(formuleType, isDateValid) {
      // Si ce n'est pas le formule_type 80001, alors c'est valide
      if (formuleType !== 80001) {
        return true;
      }
      // Si c'est le formule_type 80001, alors il faut que la date soit valide
      return isDateValid;
    },

    resetForm() {
      this.selectedClass = null;
      this.selectedFormation = null;
      this.selectedDiscipline = null;
    },
  },

  mounted() {
    this.getChildrens();
    this.getClassesConstants();
    this.getYearsConstants();
    this.getSubjectsConstants();
    this.getFormationsConstants();
    this.getProducts();
  },

  watch: {
    selectedChild(newValue) {
      this.$emit("child-selected", newValue);
    },

    selectedClass(newVal) {
      this.childClass = newVal;
      this.selectedDiscipline = null;
      this.selectedFormation = null;
      this.$emit("clear-search-results");
    },

    childClass(newVal) {
      this.$store.dispatch("updateSelectedClass", newVal);
    },

    selectedDiscipline(value) {
      if (value) {
        this.filterProducts();
      }
    },

    selectedFormation(value) {
      this.$emit("clear-search-results");
      if (value && value != "STAGE") {
        this.selectedDiscipline = null;
        this.filterProducts();
      }
    },

    selectedYear() {
      this.resetForm();
    },
  },
};
</script>

<style scoped>
.field-label {
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #06113a;
  letter-spacing: 0.01em;
}

.form-link:hover {
  color: #06113a;
  border-bottom-color: #f2cd78;
}

.form-link {
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #868ebb;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  transition: color 0.2s ease, border-color 0.2s ease;
}
</style>
